import React from "react";

import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Container from "components/Container";
import { useAuthUser } from "hooks/useAuthUser";
import { AdminRoutes } from "config/routes";
import ContainerHeaderOnly from "../Container/ContainerHeaderOnly";
import { useAppSelector } from "hooks/useAppSelector";
import { authStatusSelector } from "reduxStore/auth/selectors";
import { checkLoggedUserThunk } from "reduxStore/auth/thunks";
import { LocalStorage } from "utils/LocalStorage";
import { TermsOfUseGate } from "./TermsOfUseGate";
import { AdminMfaGate } from "./AdminMfaGate";
import { SessionIdleGuard } from "./SessionIdleGuard";

type Props = {
  headerOnly?: boolean;
};

export const ProtectedLayout: React.FC<Props> = ({ headerOnly = false }) => {
  const { user } = useAuthUser();
  const token = LocalStorage.getToken();
  const statuses = useAppSelector(authStatusSelector);
  const checkStatus = statuses[checkLoggedUserThunk.typePrefix];
  const checkingAuth =
    checkStatus?.pending ||
    (!checkStatus?.success && !checkStatus?.error);

  if (checkingAuth) {
    return <Box color="rgba(0,0,0,0.5)">...loading</Box>;
  }

  if (!token || !user) {
    return <Navigate to={AdminRoutes.Login} replace />;
  }

  return (
    <TermsOfUseGate>
      <AdminMfaGate>
        <SessionIdleGuard />
        {headerOnly ? (
          <ContainerHeaderOnly>
            <Outlet />
          </ContainerHeaderOnly>
        ) : (
          <Container>
            <Outlet />
          </Container>
        )}
      </AdminMfaGate>
    </TermsOfUseGate>
  );
};
